module.exports = __webpack_public_path__ + "static/img/klinikum.062a33e.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/ITZ_Klinikum/klinikum.jpg
// module id = UCKR
// module chunks = 0